// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"909":"60a5646b836ebd1f","927":"13349c4680330f9c"}[chunkId] + ".js";
};